import type { SxProps, Theme } from '@mui/material';

const form: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

const alert: SxProps<Theme> = {};

const dialogPaper: SxProps<Theme> = {
  borderRadius: '8px',
};

const dialogTitle: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: 16,
  py: 1.5,
};

const dialogContent: SxProps<Theme> = {
  py: 2,
};

export const styles = {
  form,
  alert,
  dialogPaper,
  dialogTitle,
  dialogContent,
} as const;
